import type { ChoreographerAssetsContext } from './__types__/ChoreographerAssetsContext.ts';

const ChoreographerComponentStub = () => {
	return null;
};

const withChoreographerStub = () => {
	return () => null;
};

export const choreographerContextStub: Omit<
	ChoreographerAssetsContext,
	'plugin' | 'useChoreographer' | 'shouldBeChoreographed' | 'useChoreographedRender'
> = {
	AutoDismissFlag: ChoreographerComponentStub as any,
	Banner: ChoreographerComponentStub as any,
	Flag: ChoreographerComponentStub as any,
	InlineDialog: ChoreographerComponentStub as any,
	Modal: ChoreographerComponentStub as any,
	PopoverContent: ChoreographerComponentStub as any,
	Popper: ChoreographerComponentStub as any,
	Popup: ChoreographerComponentStub as any,
	Spotlight: ChoreographerComponentStub as any,
	SpotlightCard: ChoreographerComponentStub as any,
	withChoreographedRender: withChoreographerStub as any,
	withChoreographedToggle: withChoreographerStub as any,
};
